<template>
    <div class="df df-center">
        <a-select v-model:value="requestPayload.year" :options="yearOption" placeholder="请选择年度" @change="getData"
            allowClear style="width: 120px">
        </a-select>
    </div>
    <div class="statistics-scroll">
        <template v-for="(item, index) in statisticsData">
            <statistics :rectificationInformation="item" :columns="columns"></statistics>
        </template>
    </div>
</template>

<script>
import { defineComponent, reactive } from 'vue';
import { getAfterSaleRepairSummary } from '@/request/view/afterSale.js';
import statistics from '@/views/afterSaleRepair/pc/statistics.vue';
import { yearOption } from '@/views/productDaily/serve/option';
import { machineOptions } from '@/components/cascader/option';


export default defineComponent({
    components: {
        statistics
    },
    setup() {
        const statisticsData = reactive([]);

        const requestPayload = reactive({
            year: new Date().getFullYear()
        });

        const getStatisticsList = () => {
            return [
                { problemType: "物料导致", total: 0, 现场维修: 0, 设备返厂: 0, 问题分析: 0, 无法处理: 0, 已完成: 0, },
                { problemType: "结构导致", total: 0, 现场维修: 0, 设备返厂: 0, 问题分析: 0, 无法处理: 0, 已完成: 0, },
                { problemType: "电子导致", total: 0, 现场维修: 0, 设备返厂: 0, 问题分析: 0, 无法处理: 0, 已完成: 0, },
                { problemType: "光学导致", total: 0, 现场维修: 0, 设备返厂: 0, 问题分析: 0, 无法处理: 0, 已完成: 0, },
                { problemType: "软件导致", total: 0, 现场维修: 0, 设备返厂: 0, 问题分析: 0, 无法处理: 0, 已完成: 0, },
                { problemType: "装配导致", total: 0, 现场维修: 0, 设备返厂: 0, 问题分析: 0, 无法处理: 0, 已完成: 0, },
                { problemType: "工艺导致", total: 0, 现场维修: 0, 设备返厂: 0, 问题分析: 0, 无法处理: 0, 已完成: 0, },
                { problemType: "其它问题", total: 0, 现场维修: 0, 设备返厂: 0, 问题分析: 0, 无法处理: 0, 已完成: 0, },
                { problemType: "合计", total: 0, 现场维修: 0, 设备返厂: 0, 问题分析: 0, 无法处理: 0, 已完成: 0, },
            ];
        };

        const setStatisticsList = (data) => {
            const dataList = getStatisticsList();
            const totalIndex = dataList.findIndex((f) => f.problemType === '合计')
            Object.keys(data).forEach((type) => {
                // 类型
                const itemIndex = dataList.findIndex((f) => f.problemType === type);
                if (itemIndex === -1) return;
                // 整改信息
                const rectificationInformation = data[type];
                Object.keys(rectificationInformation).forEach((v) => {
                    if (dataList[itemIndex][v] === undefined) return;
                    dataList[itemIndex][v] += rectificationInformation[v];
                    dataList[totalIndex][v] += rectificationInformation[v];
                    dataList[itemIndex].total += rectificationInformation[v];
                    dataList[totalIndex].total += rectificationInformation[v];
                });
            });

            return dataList;
        };

        const getData = () => {
            if (!requestPayload.year) return;
            statisticsData.length = 0;
            getAfterSaleRepairSummary(requestPayload).then((res) => {
                if (res.code === 200 && res.message === '成功' && Object.keys(res.data).length > 0) {
                    Object.keys(res.data).forEach((key) => {
                        const item = machineOptions.find((f) => f.value === key);
                        const title = `${requestPayload.year}年售后问题汇总（${item.label}）系列`;
                        const data = setStatisticsList(res.data[key]);
                        statisticsData.push({
                            title,
                            data,
                        });
                    });
                }
            });
        }

        const columns = [
            {
                title: '问题类型',
                dataIndex: 'problemType',
                align: "center",
            },
            {
                title: '发生频率',
                dataIndex: 'total',
                align: "center",
            },
            {
                title: '整改信息',
                align: "center",
                children: [
                    {
                        title: '现场维修',
                        dataIndex: '现场维修',
                        align: "center",
                    },
                    {
                        title: '设备返厂',
                        dataIndex: '设备返厂',
                        align: "center",
                    },
                    {
                        title: '问题分析',
                        dataIndex: '问题分析',
                        align: "center",
                    },
                    {
                        title: '已完成',
                        dataIndex: '已完成',
                        align: "center",
                    },
                ]
            },
        ]

        getData();

        return {
            requestPayload,
            statisticsData,
            yearOption,
            getData,
            columns,
        };
    }
});
</script>

<style lang="less" scoped>
.statistics-scroll {
    margin-top: 10px;
    height: calc(100vh - 260px);
    width: calc(100vw - 280px);
    overflow: scroll;
}
</style>
